module.exports = __webpack_public_path__ + "img/zlindex12.d0399a4c.png";